import { UIBrandedFareFeatureAvailability } from "@flights/types";
import { FC } from "react";
import { Color } from "@bookingcom/bui-react/components/Icon/Icon.types";
import {
  CheckmarkSelectedFillIcon,
  CloseCircleFillIcon,
  DollarCircleFillIcon
} from "@bookingcom/bui-assets-react/streamline/index.js";
import flights_apex_web_bf_icons_v4 from "../../utils/experiments/apex/flights_apex_web_bf_icons_v4";
import useRouteName from "../../hooks/useRouteName";

const availabilityIcons: Record<UIBrandedFareFeatureAvailability, { color: Color; icon: FC }> = {
  INCLUDED: { color: "constructive", icon: CheckmarkSelectedFillIcon },
  SELLABLE: { color: "neutral", icon: DollarCircleFillIcon },
  NOT_INCLUDED: { color: "destructive", icon: CloseCircleFillIcon }
};

export default function useAvailabilityIcon(availability: UIBrandedFareFeatureAvailability) {
  const routeName = useRouteName();
  const isBrandedFarePage = routeName === "checkout-fare";

  const showAvailabilityIcon =
    isBrandedFarePage && availability === "INCLUDED" && !!flights_apex_web_bf_icons_v4.trackWithDefaultStage();

  return showAvailabilityIcon ? availabilityIcons[availability] : undefined;
}
